import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { QUERY_KEYS } from "./queryKeys";

export function useDeployments(projectId?: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.DEPLOYMENTS, "list", projectId],
    queryFn: async () => {
      if (!projectId) {
        throw new Error("projectId is required");
      }
      const response = await api.listDeployments(projectId);
      return response.data;
    },
    enabled: !!projectId,
  });
}
